import { Component } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { nav_path } from 'src/app/app-routing.module';
import { FirestoreService } from '../../../../shared/services/firestore.service';
import { NewTagComponent } from './new-tag/new-tag.component';
import { MatDialog } from '@angular/material/dialog';
import { Tag } from '../../../../shared/interfaces/tag';

@Component({
  selector: 'anon-admin-tags',
  templateUrl: './admin-tags.component.html',
  styleUrls: ['./admin-tags.component.scss']
})
export class AdminTagsComponent {
  tags$: Observable<Tag[] | any>;
  error: any;
  nav_path = nav_path;

  constructor(
    public db: FirestoreService,
    private dialog: MatDialog,
  ) {
    this.tags$ = this.db.col$(`tags`)
      .pipe(catchError(error => {
        this.error = error;
        return throwError(error);
      }));
  }

  openCreateTagDialog() {
    this.dialog.open(NewTagComponent, {
      width: '800px',
      panelClass: 'new-tag-dialog-container',
      id: 'new-tag-dialog',
    })
  }

}
